module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("coEsD"))).then(() => parcelRequire('d0iPb'));